import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlAutomationRules = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlAutomationRules);
};
